import React, { useCallback, useEffect } from "react";
import { toJS } from "mobx";
import TeamBlock from "./TeamsList/TeamBlock";
import ReserveMatches from "./ReserveMatches";
import MatchDaysList from "./MatchDaysList/MatchDaysList";
import { useDispatch, useSelector } from "react-redux";
import { ResourceRequester } from "sulu-admin-bundle/services";
import "./styles/TopBlocks.css";
import "./styles/index.css";
import {
    leagueSuccess,
    matchesSuccess,
    matchesError,
    teamsFetch,
    teamsSuccess,
    teamsError,
    statusesFetch,
    statusesSuccess,
    statusesError,
} from "./redux/actions";

const MatchDaysPage = ({ data, locale }) => {
    const dispatch = useDispatch();
    const leagueState = useSelector((state) => state.leagueReducer.data);

    useEffect(() => {
        if (data) {
            dispatch(leagueSuccess(toJS(data)));
        }
        fetchMatches();
        fetchStatuses();
    }, []);

    const fetchMatches = useCallback(async () => {
        ResourceRequester.getList("dhbmatches", {
            "filter[leagueId]": data.id,
            limit: 300,
        })
            .then((response) => {
                const matches = response?._embedded?.dhbmatches || [];
                dispatch(matchesSuccess(matches));
            })
            .catch((error) => {
                console.error("Error fetching matches:", error);
                dispatch(matchesError(error));
            });
    }, [data.id]);

    const fetchTeams = useCallback(async (teamIds) => {
        dispatch(teamsFetch());
        ResourceRequester.getList("dhbteam", {
            ids: teamIds,
        })
            .then((response) => {
                const responseTeams = response?._embedded?.dhbteam || [];
                dispatch(teamsSuccess(responseTeams));
            })
            .catch((error) => {
                console.error("Error fetching teams:", error);
                dispatch(teamsError(error));
            });
    }, []);

    const fetchStatuses = async () => {
        dispatch(statusesFetch());
        try {
            const response = await ResourceRequester.get("matchstatus", {
                locale: locale || "en",
            });
            const statuses = response?._embedded?.matchstatus || [];
            dispatch(statusesSuccess(statuses));
        } catch (error) {
            console.error("Error fetching match statuses:", error);
            dispatch(statusesError(error));
        }
    };

    useEffect(() => {
        if (leagueState !== null) {
            fetchTeams(toJS(leagueState?.leagueTeams.join(",")));
        }
    }, [leagueState]);

    return (
        <div className="match-days-wrap">
            <div className="top-block">
                <TeamBlock />
                <ReserveMatches />
            </div>
            <MatchDaysList />
        </div>
    );
};

export default MatchDaysPage;
